import React, { useState, useEffect, useMemo, useRef } from "react";
import { Nav, Form, Tab, Modal } from "react-bootstrap";
import { PARTNER, partner_Admin, partner_Admin_Url, partner_Api } from "../../../Configuration/Partner_URL";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import Loader from "../../../Components/Common/Loader";
import { Constants } from "../../../CommonMethhods/Constants";
import Header from "../../../Components/Header";
import PartnerAdminOnboardingLeads from "../PartnerAdminOnboardingComponent/PartnerAdminOnboardingLeads";
import PartnerAdminOnboardingReject from "../PartnerAdminOnboardingComponent/PartnerAdminOnboardingReject";
import PartnerAdminOnboardingPending from "../PartnerAdminOnboardingComponent/PartnerAdminOnboardingPending";
import { toast } from "react-toastify";
import { useDebounce } from "../../../Components/useDebounce";
import PartnerAdminOnboardingAccountOpened from "../PartnerAdminOnboardingComponent/PartnerAdminOnboardingAccountOpened";
import { decryptData } from "../../../CommonMethhods/CommonMethods";
import { axiosPartnerFormData, axiosPartnerText } from "../../../CommonMethhods/axiosPartnerInterceptor";
import axios from "axios";

function PartnerAdminOnboardingDashboard() {
  const partnerFlag = localStorage.getItem("partnerFlag");
  const partnerMobileNo = localStorage.getItem("partnerMobileNo");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const partnerIdVal = localStorage.getItem("partnerId");
  const storeToken = localStorage.getItem("ssoToken");
  // const partnerCode = localStorage.getItem("getPartnerCode");
  const PartnerMobile = localStorage.getItem("PartnerMobile");
  const dateRange=localStorage.getItem("dateRange")
  const partnerTabStatus=localStorage.getItem("PartnerTabStatue")
  const getFromDate = localStorage.getItem("dematLeadFromDate");
  const getToDate = localStorage.getItem("dematLeadToDate");
  const [linecard, setLinecard] = useState("");
  const [loader, setLoader] = useState(false);
  const [tabStatus, setTabStatus] = useState(partnerTabStatus?partnerTabStatus:"pending");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [partnerOnboardingData, setPartnerOnboardingData] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [dayWiseDate, setDayWiseDate] = useState(dateRange? dateRange : "this-month");
  const [customDate, setCustomDate] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [name, setName] = useState("");
  const [serverError, setServerError] = useState("");
  const [partnerId, setPartnerId] = useState("");
  const controllerRef = useRef(null);

  if (storeToken == null) {
    window.location.replace("/")
  }
  localStorage.setItem("PartnerTabStatue", tabStatus);

  useEffect(() => {
    if (localStorage?.getItem("partnerRole") === "Partner" ||
      localStorage?.getItem("partnerRoleNew") === "Partner") {
      getPartnerId();
    }
  }, []);


  const getPartnerId = async () => {
    try {
      const getStatus = await axiosPartnerText.get(
        `${partner_Api.GET_PID_DETAILS}?mobile=${partnerFlag == "true" ? partnerMobileNo : PartnerMobile}`,
      );

      const res = decryptData(getStatus?.data);
      let decryptedDematData = JSON.parse(res);
      if (decryptedDematData?.status === 0) {
        setPartnerId(decryptedDematData?.data?.info);
      } else {
        toast.error(decryptedDematData?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const debouncedValue = useDebounce(name, 1000);
  useEffect(() => {
    handleSearchName(debouncedValue);
  }, [debouncedValue]);

  const handleSearchName = () => {
    if (name?.length > 0) {
      dematLeadTrackingData(page, tabStatus, 10, dayWiseDate);
    }
    setScrollLoader(false);
  };

  useEffect(() => {
    if (localStorage.getItem("activeTab")) {
      setTabStatus(localStorage.getItem("activeTab"));
    }

    if (localStorage?.getItem("partnerRole") === "Partner" ||
      localStorage?.getItem("partnerRoleNew") === "Partner") {

      if (name?.length < 1 && partnerId?.partnerCode) {
        // if (dayWiseDate === "Custom" && getFromDate?.length > 0 && getToDate?.length > 0) {
        //   dematLeadTrackingData(page, tabStatus, 10, dayWiseDate);
        // }else if (dayWiseDate !== "Custom") {
        //   dematLeadTrackingData(page, tabStatus, 10, dayWiseDate);
        // }

        if(dayWiseDate!==""){
          dematLeadTrackingData(page, tabStatus, 10, dayWiseDate);
        }
      }
    }
    return () => {
      localStorage.removeItem("activeTab");
    };
  }, [page, tabStatus, dayWiseDate, name == "", partnerId?.partnerCode]);

  useEffect(() => {
    if (localStorage.getItem("activeTab")) {
      setTabStatus(localStorage.getItem("activeTab"));

    }
    // if(page > 1){
    if (localStorage?.getItem("partnerRole") === "Admin") {
      if (name?.length < 1
        // && partnerCode
      ) {
        // dematLeadTrackingData(page, tabStatus, 10, dayWiseDate);
      }
    }
    return () => {
      localStorage.removeItem("activeTab");
    };
  }, [page, tabStatus, dayWiseDate, name == ""]);


  const dematLeadTrackingData = async (pages = 1, tab, limit = 10, dayWise) => {
    if (page === 1) {
      setLoader(true);
    }

    if (controllerRef.current) {
      console.log("Aborting previous request...");
      controllerRef.current.abort();
    }

    const thisController = new AbortController();
    controllerRef.current = thisController;
    console.log("New controller created");

    try {
      const getLeadData = await axiosPartnerText.get(
        `${partner_Admin.Get_Demat_Lead_Tracking_Url}?search=${name}&partnerCode=${
        // partnerCode !== null ? partnerCode : 
        partnerId?.partnerCode}&status=${tab}&page=${pages}&limit=${limit}&range=${dayWise}&to=${getToDate ? getToDate : toDate}&from=${getFromDate?getFromDate:fromDate}`,

        {
          signal: controllerRef.current.signal,
        }
      );
      const res = decryptData(getLeadData?.data);
      let decryptedLeadData = JSON.parse(res);
      if (decryptedLeadData?.status === 0) {
        setServerError("");
        setTotalCount(decryptedLeadData?.data?.total);
        if (pages > 1) {
          setPartnerOnboardingData((prev) => {
            return [...prev, ...decryptedLeadData?.data?.leads];
          });
        } else {
          setPartnerOnboardingData(decryptedLeadData?.data?.leads);
        }
      } else {
        setServerError(decryptedLeadData?.data?.message);
        setPartnerOnboardingData([]);
        toast.error(decryptedLeadData?.data?.message);
      }
    } catch (error) {
      if (axios.isCancel(error) || error.name === "CanceledError" || error.name === "AbortError") {
        console.log("Request aborted — skipping loader off");
        return;
      }
      setServerError(error?.message)
      console.log(error);
    } finally {
      if (!thisController.signal.aborted) {
        setLoader(false);
      }
      setScrollLoader(false);
    }
  };


  if (storeToken == null) {
    window.location.replace("/");
  }
  // for pagination start
  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(totalCount <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
        setLoader(false);
      }
    }
  };

  // for pagination end
  function handleTabStatus(status) {
    setTabStatus(status);
    setPage(1);
    setName("");
    localStorage.setItem("PartnerTabStatue", tabStatus);
  }

  const handleOnChange = (e) => {
    localStorage.removeItem("dematLeadFromDate")
    localStorage.removeItem("dematLeadToDate")
    if(e?.target?.value) localStorage.setItem("dateRange",e?.target?.value)
    if (e?.target?.value !== "Custom") {
      setDayWiseDate(e?.target?.value);
      setName("");
      setFromDate("");
      setToDate("");
    } else {
      setDayWiseDate(e?.target?.value);
      setName("");
      setCustomDate(true);
    }
  };

  const serachBar = useMemo(() => {
    if (name === "") {
      return partnerOnboardingData;
    } else if (partnerOnboardingData && partnerOnboardingData?.length > 0) {
      return partnerOnboardingData?.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(name.toLowerCase())
        )
      );
    }
  }, [name, partnerOnboardingData]);

  function SubmitButton() {
    if (fromDate && toDate) {
       localStorage.setItem("dematLeadFromDate", fromDate);
       localStorage.setItem("dematLeadToDate", toDate);

      return (
        <button
          type="button"
          className="rej-btn "
          onClick={() => {
            dematLeadTrackingData(page, tabStatus, 10, dayWiseDate);
            setCustomDate(false);
          }}
        >
          Submit
        </button>
      );
    } else {
      return (
        <button type="button" className="rej-btn" disabled>
          Submit
        </button>
      );
    }
  }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");


  const getEdit = async (id,client_type) => {
    try {
      const getEditResp = await axiosPartnerText.get(
        `${partner_Api.GET_EDIT}?id=${id}&type=${client_type}`,
      );
      let respData = decryptData(getEditResp.data);
      let decryptedResp = JSON.parse(respData);
      if (decryptedResp?.data?.status === "ACCOUNT OPNED") {
        toast.success(decryptedResp?.data?.status)
      }
      else if (decryptedResp?.data?.status === "REJECTED" || decryptedResp?.data?.status === "RESUME") {
        
        window.open(`${decryptedResp?.data?.url}`, "_blank");
      }
      if (decryptedResp?.status === 1) {
        toast.error(decryptedResp?.message)
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const downloadFile = async(url)=>{
  //   const response = await axios.get(url, {
  //     headers: {
  //       // "Content-Type": "text/plain",
  //           Authorization: `Bearer ${partnerFlag == "true" ? partnerSsoToken : storeToken}`,
  //     }

  //   })
  //   const headers = response.headers
  //   if(headers["content-type"] !== "text/csv"){
  //     toast.error("No Data Found")
  //     return
  //   }
  //   const binary = [];
  //   binary.push(response.data)
  //   const href = window.URL.createObjectURL(new Blob(binary, {type: "text/csv"}))
  //   const link = document.createElement("a")
  //   link.href = href
  //   link.setAttribute("download", "lead.csv")
  //   document.body.appendChild(link)
  //   link.click();

  //   document.body.removeChild(link)
  //   window.URL.revokeObjectURL(href);
  // }
  const downloadFile = async (url) => {
    const response = await axiosPartnerFormData.get(url);

    const headers = response.headers;
    if (headers["content-type"] !== "text/csv") {
      toast.error("No Data Found");
      return;
    }

    // ✅ Format current date as YYYY_MM_DD
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${yyyy}_${mm}_${dd}`;

    // ✅ Create dynamic filename
    const filename = `CLIENT_DATA_${formattedDate}.csv`;

    const binary = [];
    binary.push(response.data);
    const href = window.URL.createObjectURL(new Blob(binary, { type: "text/csv" }));
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(href);
  };



  return (
    <>
      <Header portal={"TELECALLER"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="onboarding-pending partner-onboarding">
        <div className="tab-content" id="myTabContent">
          <Tab.Container id="left-tabs-example" activeKey={tabStatus}>
            {/* page tabs */}
            <div>
              <Nav variant="nav tabs page-tabs">
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("pending")}
                >
                  <Nav.Link eventKey="pending" className="partner-navlink">Pending</Nav.Link>
                </li>

                {
                  localStorage?.getItem("partnerRole") === "Partner" ||
                    localStorage?.getItem("partnerRoleNew") === "Partner" ?
                    <li
                      className="nav-item"
                      onClick={() => handleTabStatus("opened")}
                    >
                      <Nav.Link eventKey="opened" className="partner-navlink">Account Opened</Nav.Link>
                    </li>
                    : null
                }

                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("Leads")}
                >
                  <Nav.Link eventKey="Leads" className="partner-navlink">Leads</Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("rejected")}
                >
                  <Nav.Link eventKey="rejected" className="partner-navlink">Rejected</Nav.Link>
                </li>
              </Nav>
            </div>

            <div className="onboarding-secondary-tab-list">
              <div className="search-box">
                <div className="form-group">
                  <div className="for-position oms-search partner-search">
                    <input
                      type="text"
                      className="input-st"
                      placeholder="Search here..."
                      autoComplete="off"
                      id="trad-map"
                      value={name}
                      // onKeyUp={handleChange}
                      onChange={(e) => {
                        setName(e?.target?.value);
                        setPage(1);
                      }}
                      onInput={(e) => {
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;

                  let input = e.target.value.toUpperCase();
                  input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                          input = input.replace(/\s{2,}/g, " "); 
                          input = input.replace(/^\s+/, ""); 

                  if (input.length > 100) input = input.slice(0, 100);
                  e.target.value = input;
                  e.target.setSelectionRange(start, end);
                }}
                    />
                    {/* <span
                      className="icon-search-bar"
                      onClick={(e) => handleChange(e)}
                    /> */}
                  </div>
                </div>
              </div>
              <div className="menu-rank-wrapper partner-menu">
                {/* <div className="sorting-arrow-wrapper">
                                    <img src={upArrow} alt="up-arrow" onClick={() => sortascending()} className="sorting-arrow " />
                                    <img src={downArrow} alt="down-arrow" onClick={() => sortdescending()} className="sorting-arrow " />
                                </div> */}
                <div
                  onClick={() => downloadFile(`${partner_Admin_Url}/admin/client/leads/csv?partnerCode=${
                    // partnerCode !== null ? partnerCode : 
                    partnerId?.partnerCode}&status=${tabStatus}&to=${toDate}&from=${fromDate}&range=${dayWiseDate}`)}
                  className={
                    partnerOnboardingData && partnerOnboardingData.length > 0
                      ? ""
                      : "disabled-link"
                  }
                >
                  {/* <img src={download} alt="download" /> */}
                  <span className="icon-download"></span>
                </div>
                <div className="card-right card-tabs">
                  <div className="dropdown-filter">
                    <Form.Select
                      size="lg"
                      aria-label="Default select example"
                      onChange={(e) => handleOnChange(e)}
                      defaultValue={dayWiseDate}
                    >
                      <option value="this-month">This Month</option>
                      <option value="today">Today</option>
                      <option value="yesterday">Yesterday</option>

                      <option value="this-week">This Week</option>
                      <option value="last-week">Last Week</option>
                      <option value="last-month">Last Month</option>
                      <option value="till-date">Till Date</option>
                      <option value="Custom">Custom Range</option>
                    </Form.Select>
                  </div>
                </div>
                <div className="menu-wrapper">
                  {/* <span
                    className="icon-block-menu"
                    onClick={handleGridView}
                  ></span> */}
                  {/* <span
                    className="icon-horizontal-menu"
                    onClick={handleListView}
                  ></span> */}
                </div>
              </div>
            </div>
            <div className="for-grid-section">
              {loader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : (
                <Tab.Content>
                  <PartnerAdminOnboardingLeads
                    partnerOnboardingData={partnerOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serachBar={serachBar}
                    getEdit={getEdit}
                    serverError={serverError}
                  />
                  <PartnerAdminOnboardingReject
                    partnerOnboardingData={partnerOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serachBar={serachBar}
                    getEdit={getEdit}
                    serverError={serverError}
                  />
                  <PartnerAdminOnboardingPending
                    partnerOnboardingData={partnerOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serachBar={serachBar}
                    getEdit={getEdit}
                    serverError={serverError}
                  />
                  <PartnerAdminOnboardingAccountOpened
                    partnerOnboardingData={partnerOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serachBar={serachBar}
                    getEdit={getEdit}
                    serverError={serverError}
                  />
                </Tab.Content>
              )}
            </div>
          </Tab.Container>
        </div>
        {customDate && customDate ? (
          <Modal
            show={customDate}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="setting-model partner-modal-rejection"
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                <h2 className="model-title">Custom Date</h2>
              </Modal.Title>
              <button type="button" className="btn-close" aria-label="Close">
                <span
                  className="icon-close"
                  onClick={() => setCustomDate(false)}
                ></span>
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="custom-modal-wrapper row">
                <div className="col-md-6  col-sm-12">
                  <label className="form-label">{Constants.From_Date}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="form-input"
                    onChange={(e) => setFromDate(e?.target?.value)}
                    max={DateReverse}
                  />
                </div>
                <div className="col-md-6  col-sm-12">
                  <label className="form-label">{Constants.To_Date}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="form-input"
                    onChange={(e) => setToDate(e?.target?.value)}
                    max={DateReverse}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <SubmitButton />
            </Modal.Footer>
          </Modal>
        ) : null}
      </main>
    </>
  );
}

export default PartnerAdminOnboardingDashboard;
